import { render, staticRenderFns } from "./ContainerRedaction.vue?vue&type=template&id=ab68f296&scoped=true"
import script from "./ContainerRedaction.vue?vue&type=script&lang=ts"
export * from "./ContainerRedaction.vue?vue&type=script&lang=ts"
import style0 from "./ContainerRedaction.scss?vue&type=style&index=0&id=ab68f296&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab68f296",
  null
  
)

export default component.exports